import { rememberPayload } from './apply'
import { wireValue } from './entity-edits'
import { mergePatch } from './merge-patch'
import { getRaw, hasRaw } from './raw'

const SETTING_WRAPPER_FIELDS = [
  'actual',
  'notOverridable',
  'countryOverrideIllegal',
] as const

/** Keep unknown setting keys when a wrapper field is replaced. */
export function carrySettingUnknown(source: unknown, target: unknown): void {
  if (!source || typeof source !== 'object' || !hasRaw(source)) {
    return
  }
  if (!target || typeof target !== 'object') {
    return
  }

  const raw = getRaw(source)
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return
  }

  const view = target as Record<string, unknown>
  const overlay: Record<string, unknown> = {}
  for (const key of SETTING_WRAPPER_FIELDS) {
    if (view[key] !== undefined) {
      overlay[key] = wireValue(view[key])
    }
  }

  rememberPayload(target, mergePatch(raw, overlay))
}
